import { useConditionalText } from '..'
import { MaybeUserInfo } from '../../types/types'
import { formatBasicDateStr } from '../../utils'

export const useLatestLogin = (user: MaybeUserInfo) => {
  const latestLoginDateStr = formatBasicDateStr(user?.viimeisinKirjautuminen)

  const hasLatestLogin = latestLoginDateStr != null

  const latestLoginTranslation = useConditionalText(
    hasLatestLogin,
    'pages.frontPage.sections.userInfo.lastVisited',
    'pages.frontPage.sections.membership.notMember'
  )

  const latestLogin = hasLatestLogin
    ? `${latestLoginTranslation} ${latestLoginDateStr}`
    : latestLoginTranslation

  return latestLogin
}
